import { render, staticRenderFns } from "./metric-target.vue?vue&type=template&id=46dbb75c&scoped=true&"
import script from "./metric-target.vue?vue&type=script&lang=js&"
export * from "./metric-target.vue?vue&type=script&lang=js&"
import style0 from "./metric-target.vue?vue&type=style&index=0&id=46dbb75c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dbb75c",
  null
  
)

export default component.exports